import { ScheduleFrequencies, Weekdays, DaysOfWeek } from "constants/reportSubscriptions";

const dayShort = (day) => DaysOfWeek.find((d) => d.value === day)?.short || day;

const formatDays = (frequency, days = []) => {
	if (frequency === ScheduleFrequencies.Daily) {
		const isWeekdays =
			days.length === Weekdays.length &&
			Weekdays.every((d) => days.includes(d));
		if (isWeekdays) return "every weekday";
		if (days.length === 7) return "every day";
	}
	if (!days.length) return "no days selected";
	return `every ${days.map(dayShort).join(" & ")}`;
};

// Convert an "HH:mm" (24-hour) string into a friendly "h:mm AM/PM" label.
// Falls back to the raw input if the value isn't in the expected shape.
const formatTime = (timeValue) => {
	if (!timeValue) return "";
	const match = /^(\d{1,2}):(\d{2})/.exec(timeValue);
	if (!match) return timeValue;
	const hours24 = parseInt(match[1], 10);
	const minutes = match[2];
	const period = hours24 < 12 ? "AM" : "PM";
	const hours12 = hours24 % 12 === 0 ? 12 : hours24 % 12;
	return `${hours12}:${minutes} ${period}`;
};

// Strips the IANA region prefix to produce a short label, e.g. "Australia/Sydney" -> "Sydney"
const shortTimezone = (timezone) => {
	if (!timezone) return "";
	const parts = timezone.split("/");
	return parts[parts.length - 1].replace(/_/g, " ");
};

export const formatScheduleSummary = ({
	name,
	reportName,
	format,
	frequency,
	days,
	time,
	timezone,
	email,
}) => {
	const reportLabel = reportName && format ? `${reportName} (${format})` : reportName || "Report";
	const heading = name ? `${name} — ${reportLabel}` : `${reportLabel} with current filters`;
	const cadence = `Delivered ${formatDays(frequency, days)} at ${formatTime(time)} ${shortTimezone(timezone)}`.trim();
	const recipient = email ? `to ${email}` : "";
	return [heading, cadence, recipient].filter(Boolean).join("\n");
};

export const formatScheduleLine = ({ frequency, days, time, timezone }) =>
	`${formatDays(frequency, days)} at ${formatTime(time)} ${shortTimezone(timezone)}`.trim();
